module.exports = __webpack_public_path__ + "static/media/bw-social-fb.15924547.svg";